import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enUS from '@/i18n/en-US'
import zhCN from '@/i18n/zh-CN'

Vue.use(VueI18n)

const i18n = new VueI18n({
	locale: 'enUS',
	fallbackLocale: 'enUS',
	messages: {enUS, zhCN}
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js